var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.allowedItems.length
    ? _c(
        "div",
        { staticClass: "section-categoryBarBox", attrs: { id: "bar" } },
        [
          _vm.isChristmas
            ? _c("div", { staticClass: "christmas__header" })
            : _vm._e(),
          _vm.isEaster
            ? _c("div", { staticClass: "easter__header" })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "section-categoryBarCont",
              class: { scroll: _vm.offsetBarTop }
            },
            [
              _c("div", { staticClass: "section-categoryBarBgg" }, [
                _c(
                  "div",
                  { staticClass: "section-categoryBar" },
                  [
                    _c(
                      "div",
                      { staticClass: "section-categoryBar__menu" },
                      [
                        _c(
                          "swiper",
                          {
                            ref: "swiperSS",
                            staticClass: "list",
                            attrs: {
                              options: _vm.settingsMenu,
                              initialSlide: _vm.items.length,
                              rtl: this.$store.state.rtl
                            }
                          },
                          _vm._l(_vm.allowedItems, function(item, index) {
                            return _c(
                              "swiper-slide",
                              {
                                key: index,
                                staticClass: "list__item",
                                class: item.htmlClass,
                                attrs: { id: item.htmlId }
                              },
                              [
                                !item.url
                                  ? _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: item.pageUrl,
                                          target: item.htmlTarget
                                        }
                                      },
                                      [
                                        item.image.jpg
                                          ? _c(
                                              "picture",
                                              [
                                                _vm._l(
                                                  item.image.sourcesTypes,
                                                  function(sourceType, index) {
                                                    return _c("source", {
                                                      key: index,
                                                      attrs: {
                                                        srcset:
                                                          item.image[
                                                            sourceType
                                                          ],
                                                        type:
                                                          "image/" + sourceType
                                                      }
                                                    })
                                                  }
                                                ),
                                                _c("img", {
                                                  attrs: {
                                                    src: item.image.jpg,
                                                    alt: item.title
                                                  }
                                                })
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.title) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: item.url,
                                          target: item.htmlTarget
                                        }
                                      },
                                      [
                                        item.image.jpg
                                          ? _c(
                                              "picture",
                                              [
                                                _vm._l(
                                                  item.image.sourcesTypes,
                                                  function(sourceType, index) {
                                                    return _c("source", {
                                                      key: index,
                                                      attrs: {
                                                        srcset:
                                                          item.image[
                                                            sourceType
                                                          ],
                                                        type:
                                                          "image/" + sourceType
                                                      }
                                                    })
                                                  }
                                                ),
                                                _c("img", {
                                                  attrs: {
                                                    src: item.image.jpg,
                                                    alt: item.title
                                                  }
                                                })
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.title) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                              ],
                              1
                            )
                          }),
                          1
                        ),
                        _c("div", {
                          staticClass: "swiper-button-next swiper-button-white",
                          attrs: { id: "button-next-relacionados" },
                          on: {
                            click: function($event) {
                              return _vm.swiperNext()
                            }
                          }
                        }),
                        _c("div", {
                          staticClass: "swiper-button-prev swiper-button-white",
                          attrs: { id: "button-prev-relacionados" },
                          on: {
                            click: function($event) {
                              return _vm.swiperPrev()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("search-catalog-bar")
                  ],
                  1
                )
              ])
            ]
          ),
          _vm.isHalloween
            ? _c("div", { staticClass: "halloween__header" }, [
                _c("img", {
                  attrs: {
                    src: "/public/halloween/spiders.png",
                    alt: "Halloween"
                  }
                })
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }